export default __webpack_public_path__ + "static/media/IL.207af815.svg";